import { initializePdfFonts, PdfDocument, PdfStyle, PDFTable, PDFTableHeader } from '@reapitform/common-ui'
import React from 'react'
import { AgreementActivityLogHeader } from './header'
import { AgreementActivityLogFooter } from './footer'
import { IDocumentActivity, IDocumentActivityLog } from '../../../api/types'
import { Font, Text, View } from '@react-pdf/renderer'
import dayjs from 'dayjs'
import { OrganizationContactContextValue } from '../../../hooks/use-orgazination-contact'
import { ActivityLogPDFStyle } from './style'

export interface AgreementActivityLogPDFProps {
  data?: IDocumentActivityLog | null
  agreementName: string
  organizationData: OrganizationContactContextValue
}

const activityLogTableHeader: PDFTableHeader<IDocumentActivity>[] = [
  {
    key: 'dateTime',
    title: 'WHEN',
    renderText: (rowData) => dayjs(rowData.dateTime).format('D MMM YYYY, H:mm A'),
    width: '160px',
  },
  {
    key: 'description',
    title: 'ACTIVITY',
  },
]

export const AgreementActivityLogPDF: React.FC<AgreementActivityLogPDFProps> = ({
  data,
  agreementName,
  organizationData,
}) => {
  React.useEffect(() => initializePdfFonts(Font), [])

  if (!data) return

  return (
    <PdfDocument style={ActivityLogPDFStyle.page}>
      <AgreementActivityLogHeader organizationData={organizationData} />
      <View style={{ marginBottom: '1.15cm', fontSize: '16px' }}>
        <Text style={PdfStyle.bold}>{agreementName}</Text>
        <Text>{data.propertyAddress}</Text>
      </View>
      <PDFTable headers={activityLogTableHeader} rows={data.activities} emptyMessage="" />
      <AgreementActivityLogFooter organizationData={organizationData} />
    </PdfDocument>
  )
}
